export default function syncHistorySessionClickable(session, needsPolling, shouldKeepClickable, originMsgMapRef) {
    if (!session) return;

    try {
        const historySessions = JSON.parse(localStorage.getItem('grt_history_sessions') || '[]');
        const sessionIndex = historySessions.findIndex((item) =>
            typeof item === 'object' ? item.sessionId === session?.session_id : item === session?.session_id
        );

        if (sessionIndex !== -1 && typeof historySessions[sessionIndex] === 'object') {
            if (needsPolling) {
                historySessions[sessionIndex].canPause = true;
            } else if (shouldKeepClickable) {
                const sessionData = originMsgMapRef && originMsgMapRef.current ? originMsgMapRef.current[session?.session_id] : null;
                const isTaskStopped = sessionData && sessionData.status === -1;

                if (!isTaskStopped) {
                    historySessions[sessionIndex].isClickable = true;
                } else {
                    historySessions[sessionIndex].isClickable = false;
                }
            }

            localStorage.setItem('grt_history_sessions', JSON.stringify(historySessions));
        }
    } catch (error) {
        console.error('🔥 切换会话时更新本地存储状态失败:', error);
    }
}


